<template>
  <a :href="link" target="_blank" class="home-related-course">
    <div class="img mb-2" :class="{ 'no-cover': !cover }" :style="styles">
      <i v-if="!cover" class="icon-blitzpay-placeholder"></i>
    </div>
    <div class="title">{{ name }}</div>
  </a>
</template>

<script>
import get from "lodash/get";

export default {
  props: {
    course: Object
  },
  computed: {
    cover() {
      return get(this.course, "product.picture", "");
    },
    styles() {
      if (this.cover) {
        return `
          background-image: linear-gradient(0deg, rgba(0, 26, 24, 0.20) 0%, rgba(0, 26, 24, 0.20) 100%), url(${this.cover});
          background-size: cover, cover;
          background-blend-mode: overlay, normal;
        `;
      }

      return "";
    },
    name() {
      return get(this.course, "name") || get(this.course, "product.name");
    },
    link() {
      return (
        get(this.course, "link_sale_page") ||
        get(this.course, "product.checkout_url")
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.home-related-course {
  display: flex;
  padding-top: 4px;
  flex-direction: column;
  text-decoration: none;
  position: relative;
  border-radius: 8px;

  .img {
    background-repeat: no-repeat, no-repeat;
    background-position-x: center, center;
    background-position-y: center, center;
    width: 100%;
    height: 0;
    padding-bottom: 100%;
    border-radius: 6px;
    min-width: 150px;
    min-height: 150px;
    position: relative;
    border-width: none;
    // transition: outline 0.3s ease-in-out, filter 0.3s ease-in-out;
    filter: brightness(70%);
    &.no-cover {
      filter: brightness(100%);
    }

    &:hover {
      outline: 3px solid #6b3ead;
      filter: brightness(100%);
    }
    .icon-blitzpay-placeholder {
      font-size: 48px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  small {
    opacity: 0.6;
    font-weight: 600;
  }

  .title {
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }

  .modules {
    color: #bebfc7;
    font-size: 12px;
    font-weight: 600;
  }
}
</style>
